import React from 'react';
import PropTypes from 'prop-types';
import { isYes } from '../../utils/helpers';

export const DependentChildrenAccordionItem = ({ formData }) => {
  if (
    !formData?.veteranChildrenCount ||
    formData?.veteranChildrenCount === '0'
  ) {
    return null;
  }
  const veteransChildren = formData?.veteransChildren || [];
  const showSchoolAttendance = veteransChildren.some(child =>
    isYes(child?.inSchool),
  );
  const showSeriouslyDisabled = veteransChildren.some(child =>
    isYes(child?.seriouslyDisabled),
  );
  const showMoreThanThreeDependents = veteransChildren.length === 3;
  const showLivesElsewhere =
    formData?.childrenLiveTogetherButNotWithSpouse !== undefined &&
    !isYes(formData?.childrenLiveTogetherButNotWithSpouse);
  const showAdditionalDocuments =
    showMoreThanThreeDependents || showLivesElsewhere;

  return (
    <va-accordion-item level={5} bordered header="Dependent children">
      <p>You’ll need to submit these documents:</p>
      <ul>
        <li className="vads-u-margin-bottom--2">
          <strong>If you don’t live in the U.S. or its territories</strong>, a
          birth certificate that shows the Veteran as the parent
        </li>
        <li className="vads-u-margin-bottom--2">
          <strong>If children are adopted</strong>, an adoption decree or a
          revised birth certificate
        </li>
        {showSchoolAttendance && (
          <li className="vads-u-margin-bottom--2">
            <strong>If your child is over 18 but under 23</strong>, a Request
            for Approval of School Attendance (VA Form 21-674)
            <span className="vads-u-display--block">
              <va-link
                href="https://www.va.gov/find-forms/about-form-21-674"
                external
                text="Get VA Form 21-674 to download"
              />
            </span>
          </li>
        )}
        {showSeriouslyDisabled && (
          <li className="vads-u-margin-bottom--2">
            Medical records for each seriously disabled child
          </li>
        )}
      </ul>
      {showAdditionalDocuments && (
        <div>
          <p>You may need to submit these documents:</p>
          <ul>
            {showMoreThanThreeDependents && (
              <li className="vads-u-margin-bottom--2">
                <strong>If you have more than 3 dependents to report</strong>,
                an Application Request to Add and/or Remove Dependents (VA Form
                21-686c)
                <span className="vads-u-display--block vads-u-margin-bottom--2">
                  <va-link
                    href="https://www.va.gov/manage-dependents/add-remove-form-21-686c-674"
                    external
                    text="Add or remove dependents on VA benefits"
                  />
                </span>
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/find-forms/about-form-21-686c"
                    external
                    text="Get VA Form 21-686c to download"
                  />
                </span>
              </li>
            )}
            {showLivesElsewhere && (
              <li>
                <strong>
                  If there are children who don’t live with you and don’t reside
                  at the same address
                </strong>
                , you’ll need to submit a Statement in Support of Claim (VA Form
                21-4138)
                <span className="vads-u-display--block">
                  <va-link
                    href="https://www.va.gov/find-forms/about-form-21-4138"
                    external
                    text="Get VA Form 21-4138 to download"
                  />
                </span>
              </li>
            )}
          </ul>
        </div>
      )}
    </va-accordion-item>
  );
};

DependentChildrenAccordionItem.propTypes = {
  formData: PropTypes.object,
};
